import * as React from 'react';
import {
  DataGrid,
} from '@mui/x-data-grid';

import api from "../../services/api";
import {
  Paper,
  Typography,
  Container,
  Autocomplete,
  TextField
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useStoreActions } from 'easy-peasy';
import { NoRowsOverlay}  from '../../components';


const GestaoCNAEs = () => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [empresas, setEmpresas] = React.useState([]);
  const [rows, setRows] = React.useState([]);


  const columns = React.useMemo(
    () => [{
      field: 'selecionado',
      headerName: 'Seleção',
      type: 'boolean',
      editable: true,
      width: 100,
    },{
      field: 'codigo',
      headerName: 'Código',
      flex: 1,
    },{
      field: 'descr',
      headerName: 'Descrição',
      flex: 3,
    },{
      field: 'numRegistros',
      headerName: 'Número de registros',
      flex: 1,
    },{
      field: 'ultimoRegistro',
      headerName: 'Registro mais antigo',
      type: 'dateTime',
      valueGetter: (value) => value ? new Date(value) : null,
      flex: 1,
    }],[]
  );

  const loadEmpresas = async () => {
    startLoading();
    try {
      setEmpresas((await api.http.get('/empresas')).data);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };

  const loadEmpresaCNAEs = async (empresa) => {
    if(!empresa) {
      setRows([]);
      return;
    }
    startLoading();
    try {
      setRows(
        (await api.http.get('/empresas/'+empresa.id+'/cnaes?gestao=true')).data
      );
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };


  React.useEffect(()=> {
    loadEmpresas();
  },[]);


  const processRowUpdate = React.useCallback(
    async (newRow,oldRow) => {
      startLoading();
      try {
        await api.http.put('/empresas/'+newRow.empresaId+
                           '/cnaes/'+newRow.cnaeId,newRow);
        stopLoading();
        return newRow;
      } catch (error) {
        stopLoading({
          message: error.toString(),
          severity: 'error'
        });
        return oldRow;
      };
    },
    [],
  );

  return (
    (<Container maxWidth="false">
      <Grid container spacing={3} sx={{'my': 2}}>
        <Grid style={{'textAlign': 'left'}} size="grow">
          <Typography variant="h4">Gestão dos CNAES</Typography>
        </Grid>
        <Grid style={{'textAlign': 'right'}} size="grow">
          <Autocomplete
            size="small"
            options={empresas}
            getOptionLabel={(empresa) => empresa.nome+' ('+empresa.cnpj+')'}
            onChange={(event, newValue) => {
              loadEmpresaCNAEs(newValue);
            }}
            renderInput={(params) =>
                         <TextField
                           {...params}
                           label="Selecione a empresa"/>}/>
        </Grid>
      </Grid>
      <Paper variant="elevation" elevation={2}
             style={{
               height: 400, width: '100%'
             }}>
        <DataGrid
          rows={rows}
          getRowId={(row)=>row.cnaeId}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          disableSelectionOnClick
          processRowUpdate={processRowUpdate}
          slots={{ noRowsOverlay: NoRowsOverlay }}
          experimentalFeatures={{ newEditingApi: true }}   />
      </Paper>
    </Container>)
  );
};

export default GestaoCNAEs;
